export default interface Licenca {
    id?: number;
    obrigacaoId?: number;
    obrigacao?: string;
    empresaClienteId?: number;
    dataInicio?: Date;
    dataFim?: Date;
}

export interface QuantidadeDeLicencas {
    licencasUsadasIcmsIpi?: number;
    licencasUsadasContribuicoes?: number;
    licencasUsadas?: number;
    licencasAdquiridas?: number;
    licencasNaoUsadas?: number;
    cadastrosEfetivados?: number;
}

export interface QuantidadeDeLicencasAuditor {
    licencasUsadasAuditorIcmsIpi?: number;
    licencasUsadasAuditorContribuicoes?: number;
    licencasUsadas?: number;
    licencasNaoUsadas?: number;
    licencasAdquiridas?: number;
    cadastrosEfetivados?: number;
}

export function mapQuantidadeDeLicencasAuditor(raw: any): QuantidadeDeLicencasAuditor {
  if (!raw) return {} as QuantidadeDeLicencasAuditor;

  return {
    licencasUsadasAuditorIcmsIpi:
      raw.licencasUsadasAuditoriaIcmsIpi ??
      raw.LicencasUsadasIcmsIpi ??
      raw.LicencasUsadasAuditoriaIcmsIpi ??
      raw.licencasUsadasIcmsIpi ??
      null,

    licencasUsadasAuditorContribuicoes:
      raw.licencasUsadasAuditoriaContribuicoes ??
      raw.LicencasUsadasContribuicoes ??
      raw.LicencasUsadasAuditoriaContribuicoes ??
      raw.licencasUsadasContribuicoes ??
      null,

    licencasUsadas:
      raw.licencasUsadas ??
      raw.LicencasUsadas ??
      null,

    licencasNaoUsadas:
      raw.licencasNaoUsadas ??
      raw.LicencasNaoUsadas ??
      null,

    licencasAdquiridas:
      raw.licencasAdquiridas ??
      raw.LicencasAdquiridas ??
      null,

    cadastrosEfetivados:
      raw.cadastrosEfetivados ??
      raw.CadastrosEfetivados ??
      null
  };
}
